import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './JourneyProgress.module.scss';

import Seperator from '../assets/journey-bar-seperator.svg?react';
import JourneyStep from './JourneyStep';

type StepsType = 'regular' | 'reservation-with-fee';

interface Props {
    mobile?: boolean;
    desktop?: boolean;
    className?: string;
    step: number;
    stepsType: StepsType;
}

function JourneyProgress(props: Props) {
    const className = [
        classes.journeyBar,
        props.mobile ? classes.mobile : '',
        props.desktop ? classes.desktop : '',
        props.className,
    ].join(' ');

    const { t } = useTranslation();

    const journeySteps = useMemo(() => {
        if (props.stepsType === 'regular') {
            return (
                <>
                    <JourneyStep progress={1} step={props.step}>
                        {t('journey_bar:step_1')}
                    </JourneyStep>
                    <Seperator />
                    <JourneyStep progress={2} step={props.step}>
                        {t('journey_bar:step_2')}
                    </JourneyStep>
                    <Seperator />
                    <JourneyStep progress={3} step={props.step}>
                        {props.desktop
                            ? t('journey_bar:step_3_a')
                            : t('journey_bar:step_3_b')}
                    </JourneyStep>
                    {props.desktop && props.step >= 3 && <Seperator />}
                    {props.desktop && props.step >= 3 && (
                        <JourneyStep progress={4} step={props.step}>
                            {t('journey_bar:step_4')}
                        </JourneyStep>
                    )}
                </>
            );
        } else {
            return (
                <>
                    <JourneyStep progress={1} step={props.step}>
                        {t('journey_bar:step_5')}
                    </JourneyStep>
                    <Seperator />
                    <JourneyStep progress={2} step={props.step}>
                        {t('journey_bar:step_6')}
                    </JourneyStep>
                </>
            );
        }
    }, [props.step, props.stepsType, props.desktop, t]);

    return <div className={className}>{journeySteps}</div>;
}

export default JourneyProgress;
